import { useSetWorkspaceFilter, useWorkspaceFilter } from '@gripp/shared-logic';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { TextInput } from 'react-native-paper';
import { Colors } from '../../themes';
import { DebouncedTextInput } from '../forms';

export const WorkspacesSearchInput = () => {
  const { t } = useTranslation();
  const { data: workspaceFilter } = useWorkspaceFilter();
  const { mutateAsync: setWorkspaceFilter } = useSetWorkspaceFilter();
  const [text, setText] = useState('');

  const updateSearch = async (term: string) => {
    if (!workspaceFilter) return;
    workspaceFilter.keyword = term;
    await setWorkspaceFilter(workspaceFilter);
  };

  return (
    workspaceFilter && (
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceLength={3}
        debounceFunc={updateSearch}
        placeholder={t('workspace.filter.searchPlaceholder')}
        value={text}
        onBlur={() => null}
        onChangeText={(text) => setText(text)}
        left={<TextInput.Icon icon="magnify" color={Colors.grayFill} />}
        right={
          text ? (
            <TextInput.Icon
              icon="close"
              size={20}
              color={Colors.black}
              onPress={() => setText('')}
            />
          ) : (
            <View />
          )
        }
        height={44}
        outlineStyle={styles.inputStyle}
        disableInnerStyle={true}
      />
    )
  );
};

const styles = StyleSheet.create({
  inputStyle: {
    backgroundColor: Colors.white,
    borderColor: Colors.grayDivider,
    borderWidth: 1,
    borderRadius: 8,
  },
});
